<!-- components/IdleTimeoutModal.vue -->
<template>
  <Card class="idle-timeout-modal">
    <div class="modal-content">
      <Subtitle class="title">{{ $t('idle_title') }}</Subtitle>
      <p>
        {{ $t('idle_text') }}
      </p>

      <Button
        @click="resetOnUserDismissTimeoutModal()"
        color="brand"
        icon="time"
        >{{ $t('cancel') }}</Button
      >
    </div>
  </Card>
</template>

<script lang="ts" setup>
  import { useIdle } from '@vueuse/core';
  import { AuthService } from '~~/data/services/AuthService';
  import { watch } from 'vue';
  import { Card, Button } from '@skillstown/leap';
  import { useSessionTimeout } from '~~/stores/sessionTimeout';

  const fiveMinutes = 5 * 60 * 1000;
  const { idle } = useIdle(fiveMinutes);
  const { resetOnUserDismissTimeoutModal } = useSessionTimeout();

  watch(idle, (isIdle) => {
    if (!isIdle) {
      return;
    }
    AuthService.instance.logout();
  });
</script>

<style lang="postcss" scoped>
  .idle-timeout-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    @apply space-y-6;
  }

  .title {
    font-weight: bold;
    margin-bottom: 20px;
  }
</style>
